import { TranslationType } from '../types';

export const th: TranslationType = {
  common: {
    wallets: 'กระเป๋าเงิน',
    dashboard: 'แดชบอร์ด',
    settings: 'การตั้งค่า',
    darkMode: 'โหมดมืด',
    lightMode: 'โหมดสว่าง',
    language: 'ภาษา',
    english: 'English',
    chinese: '中文',
    russian: 'Русский',
    german: 'Deutsch',
    indonesian: 'Bahasa Indonesia',
    korean: '한국어',
    japanese: '日本語',
    thai: 'ภาษาไทย',
    blog: 'บล็อก'
  },
  footer: {
    quickLinks: 'ลิงก์ด่วน',
    about: 'เกี่ยวกับเรา',
    terms: 'ข้อกำหนดการใช้งาน',
    privacy: 'นโยบายความเป็นส่วนตัว',
    contact: 'ติดต่อเรา',
    copyright: '© 2025 XCH.live สงวนลิขสิทธิ์',
    description: 'แพลตฟอร์มการตรวจสอบขั้นสูงสำหรับกระเป๋าเงินบล็อกเชน Chia รับการแจ้งเตือนธุรกรรมแบบเรียลไทม์ ปกป้องสินทรัพย์ของคุณด้วยการแจ้งเตือนทันที และตรวจสอบกิจกรรมของกระเป๋าเงินแบบโคลด์',
    connectWithUs: 'ติดต่อเรา',
    builtBy: 'สร้างด้วย ❤️ โดยทีม Spacescan.io'
  },
  home: {
    hero: {
      title: 'ตรวจสอบกระเป๋าเงินโคลด์ Chia ของคุณ',
      subtitle: 'รับการแจ้งเตือนทางอีเมลทันทีสำหรับธุรกรรม XCH',
      input: {
        label: 'ป้อนมาสเตอร์คีย์ (96 ตัวอักษร) หรือที่อยู่ XCH',
        placeholder: 'ป้อนมาสเตอร์คีย์ (96 ตัวอักษร) หรือที่อยู่ XCH',
        helper: 'ป้อนมาสเตอร์คีย์หรือที่อยู่ XCH ของคุณเพื่อเริ่มการตรวจสอบ'
      },
      buttons: {
        cardprefix: '$12',
        card: 'ชำระด้วยบัตร',
        strprefix: '50% OFF',
        str: 'ชำระด้วย STR'
      }
    },
    features: {
      title: 'ปกป้อง Chia ของคุณก่อนที่จะสายเกินไป',
      subtitle: 'อย่ารอให้แฮกเกอร์มา - ปกป้องกระเป๋าเงินโคลด์ของคุณเชิงรุกด้วยการตรวจสอบตลอด 24/7',
      vault: {
        title: 'เปิดใช้งาน Vault และ Clawback',
        description: 'ปกป้องสินทรัพย์ของคุณด้วยคุณสมบัติตู้นิรภัยและการเรียกคืนขั้นสูง'
      },
      monitoring: {
        title: 'การตรวจสอบที่ปลอดภัย',
        description: 'ติดตามกิจกรรมกระเป๋าเงินโคลด์โดยไม่ต้องเปิดเผยคีย์ส่วนตัว'
      },
      alerts: {
        title: 'การแจ้งเตือนทันที',
        description: 'รับการแจ้งเตือนทางอีเมลทันทีสำหรับธุรกรรมทั้งหมด'
      },
      recovery: {
        title: 'การกู้คืนเงิน',
        description: 'กู้คืนเงินจากธุรกรรมที่ไม่ได้รับอนุญาตในช่วงเวลาการเรียกคืน'
      }
    },
    metrics: {
      title: 'ผลกระทบของเราในตัวเลข',
      walletsMonitored: {
        label: 'กระเป๋าเงินที่ตรวจสอบ'
      },
      alertsSent: {
        label: 'การแจ้งเตือนที่ส่ง'
      },
      transactionsAnalyzed: {
        label: 'ธุรกรรมที่วิเคราะห์'
      }
    },
    testimonials: {
      title: 'สิ่งที่ผู้ใช้ของเราพูด',
      items: [
        {
          quote: 'XCH.live ให้ความสบายใจแก่ผมเมื่อรู้ว่ากระเป๋าเงินโคลด์ของผมได้รับการตรวจสอบตลอด 24/7 การแจ้งเตือนทันทีเป็นตัวเปลี่ยนเกม',
          author: 'ไมเคิล เชน',
          role: 'เกษตรกร Chia'
        },
        {
          quote: 'การตั้งค่าง่ายเหลือเชื่อและการตรวจสอบก็เชื่อถือได้ นี่คือสิ่งที่ผมต้องการสำหรับสินทรัพย์ Chia ของผม',
          author: 'ซาร่า จอห์นสัน',
          role: 'นักลงทุนคริปโต'
        },
        {
          quote: 'โซลูชันที่ดีที่สุดสำหรับการตรวจสอบกระเป๋าเงิน Chia การแจ้งเตือนทางอีเมลรวดเร็วและแดชบอร์ดก็ใช้งานง่ายมาก',
          author: 'เดวิด คิม',
          role: 'นักพัฒนาบล็อกเชน'
        }
      ]
    }
  },
  settings: {
    title: 'การตั้งค่า',
    subtitle: 'จัดการการตั้งค่ากระเป๋าเงิน',
    notifications: {
      title: 'การแจ้งเตือน',
      emailNotifications: 'การแจ้งเตือนทางอีเมล',
      emailDescription: 'รับการอัปเดตธุรกรรมทางอีเมล',
      threshold: {
        title: 'เกณฑ์ธุรกรรม',
        description: 'จำนวน XCH ขั้นต่ำสำหรับการส่งการแจ้งเตือน (ขั้นต่ำ 1 XCH)'
      }
    },
    walletInfo: {
      title: 'ข้อมูลกระเป๋าเงิน',
      masterKey: 'มาสเตอร์คีย์'
    },
    actions: {
      save: 'บันทึกการเปลี่ยนแปลง',
      delete: 'ลบกระเป๋าเงิน'
    },
    messages: {
      success: 'บันทึกการตั้งค่าเรียบร้อยแล้ว!',
      error: {
        generic: 'ไม่สามารถอัปเดตการตั้งค่า',
        threshold: 'เกณฑ์ต้องมากกว่าหรือเท่ากับ 1 XCH',
        delete: 'ไม่สามารถลบกระเป๋าเงิน'
      },
      deleteConfirm: 'คุณแน่ใจหรือไม่ที่จะลบกระเป๋าเงินนี้? การดำเนินการนี้ไม่สามารถยกเลิกได้'
    }
  },
  wallets: {
    title: 'กระเป๋าเงินของฉัน',
    subtitle: 'จัดการและตรวจสอบกระเป๋าเงินโคลด์ของคุณ',
    status: {
      active: 'กำลังตรวจสอบ',
      pending: 'รอการชำระเงิน',
      expired: 'การตรวจสอบหมดอายุ',
      timeLeft: {
        days: 'เหลือ {{days}}ว {{hours}}ชม',
        hours: 'เหลือ {{hours}}ชม {{minutes}}น',
        minutes: 'เหลือ {{minutes}}น',
        lessThanMinute: 'เหลือน้อยกว่า 1 นาที'
      }
    },
    actions: {
      payWithCard: 'ชำระด้วยบัตร',
      completeCryptoPayment: 'ชำระด้วยคริปโตให้เสร็จสิ้น',
      renewMonitoring: 'ต่ออายุการตรวจสอบ',
      dashboard: 'แดชบอร์ด',
      settings: 'การตั้งค่า',
      addFirstWallet: 'เพิ่มกระเป๋าเงินแรก',
      removeWallet: 'ลบกระเป๋าเงิน'
    },
    messages: {
      noWallets: 'ไม่พบกระเป๋าเงิน'
    }
  },
  dashboard: {
    title: 'แดชบอร์ดกระเป๋าเงิน',
    tabs: {
      events: 'เหตุการณ์',
      addresses: 'ที่อยู่'
    },
    addresses: {
      totalAddresses: 'ที่อยู่ทั้งหมด: {{count}}',
      index: 'ดัชนี',
      address: 'ที่อยู่',
      actions: 'การดำเนินการ'
    },
    events: {
      loadMore: 'โหลดเพิ่มเติม',
      noEvents: 'ไม่พบเหตุการณ์',
      sent: 'ส่งแล้ว',
      received: 'ได้รับแล้ว',
      spent: 'ใช้แล้ว',
      pending: 'กำลังดำเนินการ',
      failed: 'ล้มเหลว',
      showDetails: 'แสดงรายละเอียด',
      hideDetails: 'ซ่อนรายละเอียด',
      block: 'บล็อก',
      viewOnSpacescan: 'ดูบน Spacescan',
      transactionHash: 'แฮชธุรกรรม',
      nftsReceived: 'ได้รับ NFT',
      nftsSent: 'ส่ง NFT',
      nftTransaction: 'ธุรกรรม NFT',
      viewNFTDetails: 'ดูรายละเอียด NFT',
      receivedNFTs: 'NFT ที่ได้รับ',
      sentNFTs: 'NFT ที่ส่ง'
    }
  },
  faq: {
    title: 'คำถามที่พบบ่อย',
    security: {
      question: 'บริการตรวจสอบของคุณปลอดภัยแค่ไหน?',
      answer: 'บริการของเราดำเนินการภายใต้มาตรฐานความปลอดภัยสูงสุด โดยใช้เฉพาะมาสเตอร์คีย์สาธารณะของคุณเพื่อวัตถุประสงค์ในการตรวจสอบ เงินของคุณปลอดภัยอย่างสมบูรณ์เนื่องจากเราไม่มีการเข้าถึงคีย์ส่วนตัวหรือความสามารถในการใช้จ่าย เราใช้มาตรฐานการเข้ารหัส BLS-12-381 ซึ่งคีย์ส่วนตัว (32 ไบต์) และคีย์สาธารณะ (48 ไบต์) ถูกแยกและเก็บรักษาอย่างปลอดภัย',
      learnMore: 'เรียนรู้เพิ่มเติมเกี่ยวกับคีย์ BLS ใน Chia →'
    },
    monitoring: {
      question: 'ความถี่ในการตรวจสอบธุรกรรมเป็นอย่างไร?',
      answer: 'ระบบของเราตรวจสอบธุรกรรมแบบเรียลไทม์ โดยตรวจสอบทุกบล็อกใหม่ในบล็อกเชน Chia เราติดตามกิจกรรมในทุกที่อยู่ที่ตรวจสอบของคุณ ให้การแจ้งเตือนทันทีสำหรับธุรกรรมใดๆ ที่ส่งผลต่อกระเป๋าเงินของคุณ'
    },
    masterKey: {
      question: 'ฉันจะหามาสเตอร์คีย์สาธารณะของกระเป๋าเงินได้อย่างไร?',
      answer: 'คุณสามารถเข้าถึงมาสเตอร์คีย์สาธารณะของคุณผ่านกระเป๋าเงิน Chia GUI หรือ CLI เราได้เตรียมวิดีโอสอนโดยละเอียดที่จะแนะนำคุณผ่านกระบวนการนี้ สำคัญ: อย่าแชร์คีย์ส่วนตัวหรือวลีเมล็ดพันธุ์ของคุณ - บริการตรวจสอบของเราต้องการเพียงมาสเตอร์คีย์สาธารณะเท่านั้น',
      videoTitle: 'วิธีค้นหามาสเตอร์คีย์สาธารณะของคุณ',
      learnMore: 'อ่านคู่มือโดยละเอียดเกี่ยวกับการค้นหาคีย์ →'
    },
    addresses: {
      question: 'มีการตรวจสอบที่อยู่กี่แห่งด้วยมาสเตอร์คีย์ของฉัน?',
      answer: 'บริการของเราตรวจสอบที่อยู่ที่สืบทอด 100 แห่งที่เชื่อมโยงกับมาสเตอร์คีย์ของคุณ ให้ความครอบคลุมที่สมบูรณ์ของกิจกรรมธุรกรรมกระเป๋าเงินของคุณ'
    },
    singleAddress: {
      question: 'ฉันสามารถตรวจสอบที่อยู่เฉพาะแทนการใช้มาสเตอร์คีย์ได้หรือไม่?',
      answer: 'ใช่ บริการของเราให้ความยืดหยุ่นในการตรวจสอบที่อยู่แต่ละแห่ง คุณสามารถเลือกที่จะตรวจสอบที่อยู่เฉพาะแห่งเดียวแทนการใช้มาสเตอร์คีย์เพื่อตรวจสอบหลายที่อยู่'
    },
    notifications: {
      question: 'ฉันจะตั้งค่าการแจ้งเตือนของฉันได้อย่างไร?',
      answer: 'คุณมีการควบคุมการแจ้งเตือนทางอีเมลอย่างสมบูรณ์ผ่านการตั้งค่ากระเป๋าเงิน แดชบอร์ดของเรามีตัวเลือกสำหรับการปรับแต่งการตั้งค่าการแจ้งเตือนตามความต้องการในการตรวจสอบของคุณ'
    },
    vault: {
      question: 'Chia vault คืออะไรและทำงานอย่างไร?',
      answer: 'Chia vault เป็นคุณสมบัติความปลอดภัยขั้นสูงที่ให้การป้องกันที่เพิ่มขึ้นสำหรับสินทรัพย์ดิจิทัลของคุณ มันใช้มาตรการความปลอดภัยเพิ่มเติม เช่น ข้อกำหนดมัลติซิกหรือธุรกรรมที่มีการหน่วงเวลา ตู้นิรภัยแยกการเก็บรักษาสินทรัพย์ออกจากเหรียญและอาจต้องการลายเซ็นหลายรายการ (มัลติซิก m-of-n) สำหรับการอนุมัติธุรกรรม',
      learnMore: 'เรียนรู้เพิ่มเติมเกี่ยวกับ Chia Vaults →'
    },
    clawback: {
      question: 'คุณสมบัติ clawback ใน Chia คืออะไร?',
      answer: 'Clawback เป็นคุณสมบัติความปลอดภัยใน Chia ที่อนุญาตให้ยกเลิกธุรกรรมภายในช่วงเวลาที่กำหนด เมื่อเปิดใช้งาน ผู้รับต้องรอจนกว่าระยะเวลาการเรียกคืนจะหมดอายุก่อนที่จะสามารถเข้าถึงเงินที่โอนได้ ซึ่งให้ชั้นความปลอดภัยเพิ่มเติมสำหรับธุรกรรม'
    },
    vaultSupport: {
      question: 'บริการของคุณรองรับคุณสมบัติ vault และ clawback หรือไม่?',
      answer: 'แม้ว่าเราจะตรวจสอบธุรกรรมที่ใช้ vault และ clawback แต่เราไม่ได้จัดการคุณสมบัติเหล่านี้โดยตรง คุณสมบัติเหล่านี้ต้องตั้งค่าเมื่อสร้างกระเป๋าเงิน บริการของเรามุ่งเน้นไปที่การตรวจสอบธุรกรรมและการส่งการแจ้งเตือนสำหรับที่อยู่ของคุณ'
    },
    tokens: {
      question: 'คุณให้บริการตรวจสอบโทเค็น Chia หรือไม่?',
      answer: 'ในปัจจุบัน บริการตรวจสอบของเรามุ่งเน้นไปที่ธุรกรรม XCH เท่านั้น ฟังก์ชันการตรวจสอบโทเค็นไม่รวมอยู่ในข้อเสนอบริการปัจจุบันของเรา'
    },
    nft: {
      question: 'มีการตรวจสอบธุรกรรม NFT หรือไม่?',
      answer: 'ในปัจจุบัน บริการของเราเชี่ยวชาญในการตรวจสอบธุรกรรม XCH การตรวจสอบธุรกรรม NFT ไม่รวมอยู่ในความสามารถของบริการปัจจุบัน'
    },
    subscription: {
      question: 'นโยบายการสมัครสมาชิกและการคืนเงินของคุณเป็นอย่างไร?',
      answer: 'บริการของเราให้บริการบนพื้นฐานการสมัครสมาชิก เนื่องจากลักษณะทันทีของบริการตรวจสอบของเรา เราไม่ให้การคืนเงินหลังจากที่บริการถูกเปิดใช้งาน โปรดตรวจสอบให้แน่ใจว่าคุณเข้าใจข้อกำหนดในการให้บริการของเราก่อนที่จะสมัครสมาชิก'
    }
  },
  notFound: {
    title: 'ไม่พบหน้า',
    lostMessage: 'อย่าให้ Chia ของคุณหายไปเหมือนหน้านี้ - สูญหายในความว่างเปล่า!',
    securityMessage: 'กลับไปที่หน้าแรกและค้นพบวิธีรักษาความปลอดภัยและติดตาม XCH ของคุณตลอด 24/7',
    protectButton: 'ปกป้อง Chia ของคุณ'
  }
}; 